import React, { memo } from "react";
import {
    ISelectToggleButtonStyledProps,
    SelectToggleButtonStyled,
    SelectToggleButtonStyledRightIconStyled
} from "./styled/SelectToggleButtonStyled";
import BinIcon from "../icon/Icon";
import { StyledComponent } from "styled-components";

interface ISelectToggleButtonProps extends React.ComponentProps<StyledComponent<"div", any, ISelectToggleButtonStyledProps, never>> {
    hideArrow?: boolean,
    children?: JSX.Element | JSX.Element[],
    isOpen?: boolean;
}

export const SelectToggleButton = memo(({children, isOpen, hideArrow, ...props}: ISelectToggleButtonProps) => (
    <SelectToggleButtonStyled className={'select-toggle'} isOpen={isOpen} {...props}>
        {children}
        {!hideArrow && (
            <SelectToggleButtonStyledRightIconStyled className="right-icon" isOpen={isOpen}>
                <BinIcon name="IcChevronDown"/>
            </SelectToggleButtonStyledRightIconStyled>
        )}
    </SelectToggleButtonStyled>
));
